<mat-card class="school-details-card">
  <mat-card-header>
    <mat-card-title>{{school.short_name}}</mat-card-title>
    <mat-card-subtitle>{{school.name}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p *ngIf="!mobile && grade" class="mat-small text-disabled-color"
       i18n="School details|School grade@@school-details-grade-sub-title">
      School grade:
    </p>
    <p *ngIf="!mobile && grade">
      {{grade}}
    </p>
    <div *ngIf="!mobile && fullDetails && types">
      <p class="mat-small text-disabled-color"
         i18n="School details|School type@@school-details-type-sub-title">
        School type:
      </p>
      <p *ngIf="!mobile && fullDetails && types">
        {{getType(school.type)}}
      </p>
    </div>
    <p *ngIf="!mobile" class="mat-small text-disabled-color"
       i18n="School details|School address@@school-details-address-sub-title">
      School address:
    </p>
    <p *ngIf="!mobile">
      {{school.address}}
      <br/>
      {{school.region_name}}
    </p>
    <div *ngIf="!mobile && !compact">
      <p class="mat-small text-disabled-color"
         i18n="School details|School phone number@@school-details-phone-number-sub-title">
        School phone number:
      </p>
      <p>{{school.phone}}</p>
      <p class="mat-small text-disabled-color" i18n="School email|School address@@school-details-email-sub-title">
        School email:
      </p>
      <p>{{school.email}}</p>
    </div>
    <div *ngIf="!mobile && fullDetails">
      <p class="mat-small text-disabled-color"
         i18n="School details|School contact person@@school-details-contact-person-sub-title">
        School contact:
      </p>
      <p *ngIf="school.contact_name">{{school.contact_name}}</p>
      <p *ngIf="!school.contact_name">&#8211;</p>
    </div>
  </mat-card-content>
</mat-card>
